import type { ReadonlySignal } from "@preact/signals";
import type { FormStore } from "@formisch/preact";
import { setInput } from "@formisch/preact";

import { InputLabel } from "./input-label.js";
import { InputError } from "./input-error.js";
import type { FieldProps } from "./shared.js";
import type { FormEmbedField } from "../../types.js";

interface RadioGroupProps {
  field: FormEmbedField;
  input: ReadonlySignal<any>;
  errors: ReadonlySignal<[string, ...string[]] | null>;
  props: FieldProps;
  disabled: boolean;
  form: FormStore;
}

export function RadioGroup({ field, input, errors, props, disabled, form }: RadioGroupProps) {
  return (
    <div
      class={`flex flex-col gap-1 ${field.width === "half" ? "w-[calc(50%-6px)]" : "w-full"}`}
      data-fv-field={field.name}
      role="radiogroup"
      aria-invalid={!!errors.value}
      aria-errormessage={`${props.name}-error`}
    >
      <InputLabel label={field.label} required={field.required} description={field.description} />
      <div class="flex flex-col gap-2 mt-1">
        {field.options?.map((opt) => (
          <label key={opt.value} class="flex items-center gap-2 text-sm text-theme-fg cursor-pointer">
            <input
              type="radio"
              name={props.name}
              value={opt.value}
              checked={input.value === opt.value}
              disabled={disabled}
              style={{ accentColor: "var(--fv-theme-primary, var(--fv-button-bg, #007145))" }}
              onChange={() => setInput(form, { path: [field.name] as any, input: opt.value })}
              onBlur={props.onBlur as any}
            />
            {opt.label}
          </label>
        ))}
      </div>
      <InputError name={props.name} errors={errors} />
    </div>
  );
}
